module.exports = __webpack_public_path__ + "static/media/arrow_back.5b682940.svg";